import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./AccountReturn.css";
import {
  getStripeConnectCallback,
  getStripeConnectStatus,
} from "Config/API/get";

export default function AccountReturn() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying your Stripe connection...");

  useEffect(() => {
    let cancelled = false;

    const runCallbackFlow = async () => {
      const token = localStorage.getItem("token");
      const accountId =
        sessionStorage.getItem("stripe_account_id") ||
        localStorage.getItem("stripe_account_id");

      if (!token || !accountId) {
        if (!cancelled) {
          setStatus("error");
          setMessage(
            "We could not find your Stripe onboarding session. Please restart onboarding from your dashboard."
          );
        }
        return;
      }

      try {
        const callbackRes = await getStripeConnectCallback(token, accountId);
        if (!callbackRes?.status) {
          throw new Error(
            callbackRes?.message || "Unable to verify Stripe connection."
          );
        }

        const statusRes = await getStripeConnectStatus(token);
        const isConnected =
          statusRes?.status &&
          (statusRes?.data?.connected ||
            statusRes?.data?.is_connected ||
            statusRes?.data?.active ||
            statusRes?.data?.onboarding_complete);

        if (!isConnected) {
          throw new Error(
            statusRes?.message ||
              "Stripe onboarding is not completed yet. Please continue onboarding."
          );
        }

        sessionStorage.removeItem("stripe_account_id");
        sessionStorage.removeItem("stripe_country_code");
        localStorage.removeItem("stripe_account_id");
        localStorage.removeItem("stripe_country_code");

        if (!cancelled) {
          setStatus("success");
          setMessage("Your Stripe account is now connected and active.");
        }
      } catch (err) {
        if (!cancelled) {
          setStatus("error");
          setMessage(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              err?.message ||
              "Unable to complete Stripe callback. Please try again."
          );
        }
      }
    };

    runCallbackFlow();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="account-return-page">
      <div className="account-return-overlay" />
      <div className="container account-return-container">
        <div className="account-return-card text-center">
          {status === "success" || status === "loading" && (
          <div className="account-return-icon-wrapper" aria-hidden="true">
            <span className="account-return-icon">✓</span>
          </div>
)}
          <p className="account-return-badge">
            {status === "loading"
              ? "Verifying Connection"
              : status === "success"
                ? "Stripe Connected"
                : "Connection Incomplete"}
          </p>

          <h1 className="account-return-title">
            {status === "loading"
              ? "Checking Stripe status..."
              : status === "success"
                ? "Congratulations!"
                : "Action Required"}
          </h1>

          <p className="account-return-description">{message}</p>

          <div className="account-return-actions">
           
            <Link to="/dashboard" className="account-return-secondary-btn">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
